import { StaticImageData } from 'next/image';
import { useState, useEffect } from 'react';

// 이미지 프리로딩을 위한 커스텀 훅
const useImagePreloader = (imageSources: StaticImageData[]) => {
  const [imagesPreloaded, setImagesPreloaded] = useState(false);

  useEffect(() => {
    const preloadImages = async () => {
      const loadPromises = imageSources.map((src) => {
        return new Promise((resolve, reject) => {
          const img = new window.Image();
          img.src = src.src;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      try {
        await Promise.all(loadPromises);
        setImagesPreloaded(true);
      } catch (error) {
        console.error('Error preloading images:', error);
      }
    };

    preloadImages();
  }, [imageSources]);

  return imagesPreloaded;
};

export default useImagePreloader;
